export default "__VITE_ASSET__K$DYEyg5__"